var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfessional = function SvgProfessional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.2 23.714C27.2 26.6 24.857 29 21.97 29H15M21.971 16.743a6.97 6.97 0 1 1-13.942 0 6.97 6.97 0 0 1 13.942 0M4.544 23.714H2.8c-.963 0-1.801-.78-1.801-1.743V15c0-.963.838-1.743 1.8-1.743h1.744zM29 21.97c0 .963-.839 1.744-1.801 1.744h-1.743V13.257H27.2c.962 0 1.8.78 1.8 1.743z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1 15C1 7.3 7.3 1 15 1s14 6.3 14 14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.614 16.743c0 3.85-1.17 6.97-2.614 6.97s-2.614-3.12-2.614-6.97S13.556 9.772 15 9.772s2.614 3.12 2.614 6.97M8.03 16.743H21.97"
  })));
};
export default SvgProfessional;